import _getIterator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/get-iterator";
import _parseInt from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/parse-int";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";
import * as types from "@/store/constants/types";
import { i18n } from "@/i18n/i18n-setup";

var TabBars =
/*#__PURE__*/
function (_Vue) {
  _inherits(TabBars, _Vue);

  function TabBars() {
    var _this;

    _classCallCheck(this, TabBars);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TabBars).apply(this, arguments));
    _this.tabList = [i18n.t("personal_futrue.tab_title[0]"), i18n.t("personal_futrue.tab_title[1]")];
    _this.activatedIndex = 0;
    return _this;
  }

  _createClass(TabBars, [{
    key: "goBack",
    value: function goBack() {
      this.routerGoBack(-1);
    }
  }, {
    key: "clickTab",
    value: function clickTab(index) {
      this.activatedIndex = index; // this.redBarIndex.push[index];

      this.hideRedBar(index);
    }
  }, {
    key: "valueChanged",
    value: function valueChanged(val, oldVal) {
      this.activatedIndex = val; // this.redBarIndex.push(parseInt(val));

      this.hideRedBar(_parseInt(val));
    }
  }, {
    key: "hideRedBar",
    value: function hideRedBar(index) {
      var redBar = document.querySelectorAll(".redBar" + index);

      if (redBar) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _getIterator(redBar), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var j = _step.value;
            j.style.display = "none";
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }
  }, {
    key: "showRedBar",
    value: function showRedBar() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.activatedIndex !== 0) {
          return;
        }

        var redBar = document.querySelectorAll(".redBar1");

        if (redBar) {
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = _getIterator(redBar), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var j = _step2.value;
              j.style.display = "block";
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      });
    }
  }, {
    key: "mounted",
    value: function mounted() {}
  }, {
    key: "activated",
    value: function activated() {
      this.showRedBar();
    }
  }]);

  return TabBars;
}(Vue);

tslib_1.__decorate([Action(types.ROUTER_GO_BACK)], TabBars.prototype, "routerGoBack", void 0);

tslib_1.__decorate([Prop()], TabBars.prototype, "value", void 0);

tslib_1.__decorate([Emit("input")], TabBars.prototype, "clickTab", null);

tslib_1.__decorate([Watch("value")], TabBars.prototype, "valueChanged", null);

TabBars = tslib_1.__decorate([Component({
  components: {}
})], TabBars);
export default TabBars;